// Singleton register for an in-app "do you really want to leave?" guard. A feature with
// unsaved state (e.g. TechPack result editor) registers a function while dirty; nav surfaces
// (sidebar, in-page back buttons) await confirmNavigation() before calling navigate(). When no
// guard is registered, confirmNavigation() resolves immediately to true. Only one guard is held
// at a time — the most recently registered wins.
//
// Why a singleton instead of a React context: the consumers (SideMenu, page-level back arrows)
// live outside the dirty feature's component tree, so a context would force lifting at app root.
// A module-scoped ref is functionally equivalent and avoids the rewiring.

type Guard = () => Promise<boolean>;

let activeGuard: Guard | null = null;

export const setUnsavedChangesGuard = (guard: Guard | null): void => {
  activeGuard = guard;
};

export const confirmNavigation = (): Promise<boolean> => {
  if (!activeGuard) return Promise.resolve(true);

  return activeGuard();
};
